import Vue from 'vue'
import Router from 'vue-router'

// steps
import Brand from './views/Brand.vue'
import Service from './views/Service.vue'
import Visit from './views/Visit.vue'
import Client from './views/Client.vue'
import Car from './views/Car.vue'
import Overview from './views/Overview.vue'
import Success from './views/Success.vue'
import Order from './views/Order.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'brand',
      component: Brand
    },
    {
      path: '/service/',
      name: 'service',
      component: Service
    },
    {
      path: '/visit/',
      name: 'visit',
      component: Visit
    },
    {
      path: '/client/',
      name: 'client',
      component: Client
    },
    {
      path: '/car/',
      name: 'car',
      component: Car
    },
    {
      path: '/overview/',
      name: 'overview',
      component: Overview
    },
    {
      path: '/success/',
      name: 'success',
      component: Success
    },
    {
      path: '/zlecenie/:code',
      name: 'order',
      component: Order
    }
  ]
})
